import * as constants from '../constants';

export default function (state = [], action) {
  switch (action.type) {
    case constants.GET_CHALLENGES_SUCCESS:
    case constants.GET_CHALLENGES_BY_SPARK_ID_SUCCESS:
      return Object.assign({}, state, {
        challenges: action.challenges.data || [],
        isRefreshRequired: false,
      });
    case constants.POST_CHALLENGE_SUCCESS:
      return Object.assign({}, state, {
        newId: action.newId.data || '-1',
        isRefreshRequired: true,
      });
    case constants.GET_CHALLENGES_ERROR:
    case constants.GET_CHALLENGES_BY_SPARK_ID_ERROR:
    case constants.GET_CHALLENGE_BY_ID_ERROR:
    case constants.POST_CHALLENGE_ERROR:
    case constants.PATCH_CHALLENGE_ERROR:
      return Object.assign({}, state, { error: action.error });
    case constants.PATCH_CHALLENGE_SUCCESS:
      return Object.assign({}, state, {
        isRefreshRequired: true,
      });
    default:
      return state;
  }
}
